package com.dotdrives.model

import kotlinx.serialization.Serializable

@Serializable
data class GoalsProgress(val financialVisible: Boolean, val progress: List<GoalRaised> = emptyList())

@Serializable
data class GoalRaised(val kind: String, val id: String, val raised: Double)
